import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
 
import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import {variables} from './Variables.js';
import { FALSE } from 'sass';


 
 
export default function WhatsnewHome() {

 

    const [isLoading,setNisLoading] = useState(false);
    const navigate = useNavigate();
    const usenavigate=useNavigate();
   
    const JsonUrlWhatsnew = variables.basename_url +'updates/index/Coinsinsight_HomeEn_TrendingNews.json';
  
      async function refda() {  
        Get_Data_WhatsNew();
  
      }


   
      useEffect(() => {
       
       
        setNisLoading(true);
   
        refda();
           },[] )




           const [JsonWhatsNewArray, setJsonJsonWhatsNewArray] = React.useState([]);

           async function Get_Data_WhatsNew(){
          
             JsonWhatsNewArray.splice(0);  //to clear All data in your page
         
            setNisLoading(true);
         
            axios.get(JsonUrlWhatsnew)  
         
                  .then(function (response) {
                  setNisLoading( false);
         
                 
                   
              
         
                  for (let i = 15; i <= 21 && i < response.data.length; i++) {
                  
                   JsonWhatsNewArray.push({
                     news_title: response.data[i].news_title,
                     news_date:response.data[i].news_date.split('T')[0],
                     image: response.data[i].image  ,
                     link:response.data[i].link,
                    Category:response.data[i].Category
                   })
                   }
             })      
            };
         
         
         
 

 


            return (
          <>
 


 <div className="most-view-box mt-40">
        <div className="section-title">
          <h3 className="title">What’s New</h3>
        </div>
        <div className="trending-sidebar-slider slick-initialized slick-slider"> 
          <div className="slick-list draggable"><div className="slick-track"  >
            <div className="post_gallery_items slick-slide slick-cloned" data-slick-index={-1} aria-hidden="true" tabIndex={-1}  >
        
              
            
        
      
              </div>
              <div className="post_gallery_items slick-slide slick-current slick-active" data-slick-index={0} aria-hidden="false" tabIndex={0} >
            
  
      
       
 {JsonWhatsNewArray.map(da=>     
  
  <div key= {da.news_title}  >   
 <div className="post-gallery-style-2 most-view-style-2">
                  <div className="post-gallery-thumb  ">
                  <a href={da.link}>
                    <img className='whats-Img rounded'     src={da.image}  alt="gallery" />
               </a>
                  </div>
                  <div className="post-gallery-content pl-4">
                    <h5 className="title"><a href={da.link }    tabIndex={-1}>{da.news_title}</a></h5>
                    <div className="meta-post-2-style">
                      <div className="meta-post-categores">
                        <a href="#" tabIndex={-1}>{da.Category}</a>
                      </div>
                      <div className="meta-post-date">
                        <span>{da.news_date}</span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Start line between news */}
             <div></div>
               {/* End line between news */}
                </div>
                 
               )}
              
       
              </div>


              
              {/* <div className="post_gallery_items slick-slide" data-slick-index={1} aria-hidden="true" tabIndex={-1} style={{width: '300px'}}>
    
           
           
 {FootBall_MostViewed.map(da=>     
  
  <div key= {da.news_title}  >   
 <div className="post-gallery-style-2 most-view-style-2">
                  <div className="post-gallery-thumb">
                    <img  style={{ maxWidth: '83px', maxHeight: '57px' }} src={da.news_imagename}  alt="gallery" />
                  
                  </div>
                  <div className="post-gallery-content">
                    <h5 className="title"><a href={da.link } tabIndex={-1}>{da.news_title}</a></h5>
                    <div className="meta-post-2-style">
                      <div className="meta-post-categores">
                        <a href="#" tabIndex={-1}>{da.Category}</a>
                      </div>
                      <div className="meta-post-date">
                        <span>{da.news_date}</span>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
               )}
           
  
              </div> */}
              {/* <div className="post_gallery_items slick-slide slick-cloned" data-slick-index={2} aria-hidden="true" tabIndex={-1} style={{width: '300px'}}>
        
               
        
 {FootBall_MostViewed.map(da=>     
  
  <div key= {da.news_title}  >   
 <div className="post-gallery-style-2 most-view-style-2">
                  <div className="post-gallery-thumb">
                    <img  style={{ maxWidth: '83px', maxHeight: '57px' }} src={da.news_imagename}  alt="gallery" />
          
                  </div>
                  <div className="post-gallery-content">
                    <h5 className="title"><a href={da.link } tabIndex={-1}>{da.news_title}</a></h5>
                    <div className="meta-post-2-style">
                      <div className="meta-post-categores">
                        <a href="#" tabIndex={-1}>{da.Category}</a>
                      </div>
                      <div className="meta-post-date">
                        <span>{da.news_date}</span>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
               )}
              
        
              </div> */}
              <div className="post_gallery_items slick-slide slick-cloned" data-slick-index={3} aria-hidden="true" tabIndex={-1} style={{width: '300px'}}>
        
         
            
             
            
              </div></div></div>
           </div>
      </div>

 
 
   
         </>
        );
    }


  
